export default "__VITE_ASSET__CQuKVEYj__"